import { render, staticRenderFns } from "./SendOrderTiktokBatch.vue?vue&type=template&id=4f2adbcc&scoped=true"
import script from "./SendOrderTiktokBatch.vue?vue&type=script&lang=js"
export * from "./SendOrderTiktokBatch.vue?vue&type=script&lang=js"
import style0 from "./SendOrderTiktokBatch.vue?vue&type=style&index=0&id=4f2adbcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2adbcc",
  null
  
)

export default component.exports